<template>
    <div :class="[isActive ? 'open dashboard-header' : 'closed dashboard-header']">
        <img v-if="route === 'class-list'" class="site-logo" src="@/assets/unsung-logo-color.png" />
        <div class="breadcrumb" v-if="route != 'class-list'">
            <span class="back-button material-icons-round" @click="goBack">
                arrow_back_ios
            </span>
            <span class="description">{{ stepBack.title }}</span>
        </div>
        <h3>{{ pageName }}</h3>
        <div class="profile-dropdown" @click="toggleClass">
            <button type="button" @click="showModal" class="logout">Log out</button>
            <span class="material-icons-round button profile-pic">face</span>
        </div>
        <Modal v-show="isModalVisible" @close="closeModal">
            <template v-slot:header>
                <b></b>
            </template>
            <template v-slot:body>
                <b>Are you sure you want to logout? <br />
                    Your active session will be disconnected.</b>
            </template>
            <template v-slot:footer>
                <div class="modal-button-group">
                    <button class="cancel-button" @click="closeModal">Cancel</button>
                    <button @click="disconnect">Logout Anyway</button>
                </div>
            </template>
        </Modal>
    </div>
</template>

<script>
    import Modal from "../components/Modal.vue";

    export default {
        name: "MainNavigation",
        props: ["pageName", "routeIndex"],
        components: {
            Modal,
        },
        data: function () {
            return {
                isActive: false,
                route: this.$route.name,
                isModalVisible: false,
            };
        },
        computed: {
            stepBack() {
                var index = this.routeIndex - 1;
                switch (index) {
                    case 2: {
                        return {
                            name: "class-info",
                            title: "Class Info",
                            params: { name: this.$route.params.name },
                        };
                    }
                    case 3: {
                        return {
                            name: "past-sessions",
                            title: "Past Sessions",
                            params: { name: this.$route.params.name },
                        };
                    }
                    case 5: {
                        return {
                            name: "class-info",
                            title: "Class Info",
                            params: { name: this.$route.params.name },
                        };
                    }
                    default: {
                        return {
                            name: "class-list",
                            title: "Class List",
                        };
                    }
                }
            },
        },
        methods: {
            goBack() {
                var nextRoute = this.stepBack;
                switch (nextRoute.name) {
                    case "class-info":
                        if (this.routeIndex == 6) {
                            this.$store.commit("SEND_MESSAGE", {
                                data: {
                                    sessionId: this.$store.state.currentSession.sessionId,
                                    teacherId: this.$store.state.teacherId,
                                },
                                opCode: this.$store.state.opCodes.EndSession,
                            });
                        }
                        this.$store.commit("SEND_MESSAGE", {
                            data: this.$store.state.currentClass.classId,
                            opCode: this.$store.state.opCodes.PastSessionsCount,
                        });
                        break;
                    case "past-sessions":
                        this.$store.commit("SEND_MESSAGE", {
                            data: this.$store.state.currentClass.classId,
                            opCode: this.$store.state.opCodes.PastSessionsBrief,
                        });
                        break;
                    default:
                        break;
                }
                return this.$router.push({
                    name: nextRoute.name,
                    params: nextRoute.params,
                }).then(()=> {
                    window.location.reload();
                });;
            },
            disconnect: function () {
                this.$store.commit("SEND_MESSAGE", {
                    data: this.$store.state.teacherId,
                    opCode: this.$store.state.opCodes.LogoutTeacher,
                });
                this.$store.commit("SET_AUTHENTICATION", false);
                this.$router.push({ path: "/login" });
                location.reload();
            },
            toggleClass: function () {
                this.isActive = !this.isActive;
            },
            showModal() {
                if (this.$store.state.currentSession.sessionStarted)
                    this.isModalVisible = true;
                else this.disconnect();
            },
            closeModal() {
                this.isModalVisible = false;
            },
        },
    };
</script>

<style lang="scss">
    .dashboard-header {
        height: 100px;
        display: flex;
        background: $tan;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
        margin-left: calc(-50vw + 50%);
        margin-right: calc(-50vw + 50%);
        align-items: center;
        justify-content: space-between;
        padding: 0 20px;
        overflow: hidden;

        &.open {
            overflow: unset;

            .profile-dropdown {
                @media only screen and (max-device-width: 414px) {
                    height: 124px;
                    flex-direction: column-reverse;
                    align-items: flex-end;
                    margin-top: 13px;

                    button {
                        margin-top: 8px;
                        margin-right: 15px;
                        z-index: 2;

                        &:before {
                            content: "";
                            display: block;
                            position: absolute;
                            border-left: 18px solid $red;
                            border-right: 8px solid transparent;
                            border-top: 8px solid $red;
                            border-bottom: 14px solid transparent;
                            transform: rotate(180deg);
                            margin-top: -28px;
                            right: 35px;
                        }
                    }
                }
            }
        }

        &.closed {
            button.logout {
                display: none;
            }
        }

        img.site-logo {
            width: 155px;
            margin-left: 0;
            padding: 1rem;
        }

        .breadcrumb {
            display: flex;
            align-items: center;

            @media only screen and (min-device-width: 768px) {
                width: 150px;
            }

            span.back-button {
                cursor: pointer;
                padding-right: 10px;
                /*@media only screen and (min-device-width: 768px) {
        padding-right: 88px;
      }*/
            }

            .description {
                @media only screen and (max-width: 768px) {
                    display: none;
                }
            }
        }

        h3 {
            text-align: center;
        }

        .profile-dropdown {
            display: flex;
            height: auto;
            justify-content: end;
            width: 30px;

            @media only screen and (min-device-width: 768px) {
                width: 210px;
            }

            .profile-pic {
                font-size: 35px;
                height: 52px;
                line-height: 52px;
                cursor: pointer;

                @media only screen and (max-device-width: 768px) {
                    flex-position: 1;
                }
            }

            button {
                margin-top: 8px;
                margin-right: 15px;
                height: 35px;
                line-height: 0px;
                background: $darkbrown;
                border-color: $darkbrown;
                color: $tan;
            }
        }
    }
</style>